"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const formik_1 = require("formik");
const InputField_1 = __importDefault(require("./InputField"));
const Button_1 = __importDefault(require("./Button"));
const errorNotification_1 = require("../errorNotification");
const NewPlantForm = ({ presets, handleNewPlant, plantApi, ...props }) => {
    // const plantApi = new PlantApi;
    const values = {
        gattung: '',
        art: '',
        sorte: '',
        deutsch_kurz: '',
    };
    const onSubmit = async (values, { setErrors, setSubmitting }) => {
        try {
            const { success, record } = await plantApi.create(values);
            if (success)
                handleNewPlant(record);
        }
        catch (error) {
            if (error.response.status === 422) {
                setErrors(error.response.data.errors);
            }
            else {
                (0, errorNotification_1.notifyError)(error.response.data.message);
            }
        }
        setSubmitting(false);
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(formik_1.Formik, { initialValues: values, onSubmit: onSubmit },
            react_1.default.createElement(formik_1.Form, { className: "space-y-2" },
                react_1.default.createElement(InputField_1.default, { name: "gattung", type: "text", label: "Gattung" }),
                react_1.default.createElement(InputField_1.default, { name: "art", type: "text", label: "Art" }),
                react_1.default.createElement(InputField_1.default, { name: "sorte", type: "text", label: "Sorte" }),
                react_1.default.createElement(InputField_1.default, { name: "deutsch_kurz", type: "text", label: "Deutsch Kurz" }),
                react_1.default.createElement("div", { className: "text-right" },
                    react_1.default.createElement(Button_1.default, { type: "submit" }, "Erstellen"))))));
};
exports.default = NewPlantForm;
